import Cleave from "cleave.js/react";
require('cleave.js/dist/addons/cleave-phone.us')

const PhoneField = (props: any) => {
  const { inputRef, ...rest } = props;
  return (
    <Cleave
      data-qatag="phone Number"
      placeholder="Phone Number"
      options={{
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-',
      }}
      htmlRef={inputRef}
      {...rest}
    />
  );
};

export default PhoneField;
